import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=badaee5e&scoped=true"
import script from "./ImageViewer.vue?vue&type=script&lang=js"
export * from "./ImageViewer.vue?vue&type=script&lang=js"
import style0 from "./ImageViewer.vue?vue&type=style&index=0&id=badaee5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badaee5e",
  null
  
)

export default component.exports